import Drawer from '@mui/material/Drawer';
import { styled } from '@mui/material/styles';
import borders from '@theme/base/borders';

export default styled(Drawer)<{ ownerState: any }>(({ theme, ownerState }) => {
  const { boxShadows, functions, transitions } = theme;
  const { openConfigurator, marginTop, width, paddingBottom } = ownerState;
  const { borderRadius } = borders;

  const configuratorWidth = 360;
  const { lg } = boxShadows;
  const { pxToRem } = functions;

  // drawer styles when openConfigurator={true}
  const drawerOpenStyles = () => ({
    width: width || configuratorWidth,
    paddingBottom: paddingBottom || '12px',
    left: 'initial',
    right: 0,
    transition: transitions.create('all', {
      easing: transitions.easing.sharp,
      duration: transitions.duration.short
    })
  });

  // drawer styles when openConfigurator={false}
  const drawerCloseStyles = () => ({
    left: 'initial',
    right: pxToRem(-350),
    transition: transitions.create('all', {
      easing: transitions.easing.sharp,
      duration: transitions.duration.short
    })
  });

  return {
    '& .MuiDrawer-root': {
      position: 'absolute',
      backgroundColor: 'red'
    },
    '& .MuiPaper-root': {
      position: 'absolute'
    },
    overflowY: 'scroll',

    '& .MuiDrawer-paper': {
      height: 'fit-content',
      margin: `${marginTop} 0 0 0`,
      padding: `0 ${pxToRem(2)} 12px`,
      borderRadius: borderRadius.xl,
      boxShadow: lg,
      jusifyContent: 'center',
      overflowY: 'auto',
      overflowX: 'hidden',
      zIndex: 70,
      ...(openConfigurator ? drawerOpenStyles() : drawerCloseStyles())
    }
  };
});
